import isUndefined from 'lodash/isUndefined';

export class Geolocation {
    static getCurrentPosition() {
        return new Promise((resolve, reject) => {
            if (isUndefined(window) || !window.navigator.geolocation) {
                reject(new Error('Geolocation not supported'));
            }

            window.navigator.geolocation.getCurrentPosition(resolve, reject);
        });
    }
}
